import { useMutation } from "@tanstack/react-query";
import { useAuth } from "../../auth/hooks/useAuth";
import { createUserQuestion } from "../../../api/userQuestion";

export const useCreateUserQuestion = () => {
    const { csrfToken } = useAuth();

    const mutation = useMutation({
        mutationFn: async (params: { answererId: string; title: string }) => {
            await createUserQuestion(
                params.answererId,
                params.title,
                csrfToken
            );
        },
    });

    return { createUserQuestion: mutation };
};
